




























































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import commentModal from "./commentModal.vue";
import qs from "@/components/queSheng.vue";
import starRate from "@/components/starRate.vue";
import {
  commentList,
  myComment,
  userCommentList,
  addUserComment,
  delUserComment,
  delComment,
  commentPraise,
  replyPraise,
} from "@/req/home";
import { locale } from "moment";
import commentListCom from "./commentList/commentList.vue";
@Component({
  components: { headerTitle, commentModal, qs, starRate, commentListCom },
})
export default class Logout extends Vue {
  public valueText = 2.5;
  public commentList: any = [];
  public hotList: any = [];
  public myCommentList: any = [];
  public gameId: any = "1";
  public isCommented: any = 0; // 是否评论过
  public isComment = 2; // 是否开启评论
  public bannedToPost = 0; // 1代表被禁言了
  public bannedDay = ""; // 禁言天数
  public isLogin = 1; // 是否登录
  public commented = 1; // 是否玩过游戏
  public grade = 1; // 评分
  public havePraise = true; // 禁止评价连续点赞
  public haveReplyPraise = true; // 禁止回复连续点赞
  public gradeList = ["讨厌", "不喜欢", "还可以", "很不错", "棒极了"];
  public commentId = "1";
  public firstReply = ""; // 顶部回复
  public footerReply = ""; // 底部回复
  @Prop({ type: Number, default: 1 }) public showNew;
  @Prop({ type: Number, default: "" }) public openComment;
  public created() {
    if (this.$route.query.id) {
      this.gameId = this.$route.query.id;
    }
    this.getList();
    this.getMyComment();
  }
  @Watch("$route")
  public routeChange(i) {
    this.gameId = this.$route.query.id;
    this.getList();
    this.getMyComment();
  }
  public getNew() {
    this.getList();
    this.getMyComment();
    this.isCommented = 1;
  }
  // 获取最新、热评
  public async getList() {
    const res = await commentList({
      token: this.$fn.cookies.getToken(),
      box_game_id: this.gameId,
    });
    if (res.code == 200) {
      this.isCommented = res.data.comment_list.is_comment;
      const arr1 = res.data.comment_list.rows.data;
      arr1.forEach((element) => {
        element.replyData = { data: [] };
        element.replyShow = 0;
        if (element.content.length > 500) {
          element.showMoreBtn = true;
          element.showContentMore = true; // 内容是否超过六行
        } else {
          element.showMoreBtn = false;
        }
      });
      this.commentList = arr1;
      const arr2 = res.data.comment_list.hot.data;
      arr2.forEach((element) => {
        element.replyData = { data: [] };
        element.replyShow = 0;
        if (element.content.length > 500) {
          element.showMoreBtn = true;
          element.showContentMore = true; // 内容是否超过六行
        } else {
          element.showMoreBtn = false;
        }
      });
      this.hotList = arr2;
    }
  }
  // 获取我的评价
  public async getMyComment() {
    const res = await myComment({
      token: this.$fn.cookies.getToken(),
      box_game_id: this.gameId,
    });
    if (res.code == 200) {
      const arr = res.data.comment_list;
      this.isComment = 1;
      arr.forEach((element) => {
        element.replyData = { data: [] };
        element.replyShow = 0;
        if (element.content.length > 500) {
          element.showMoreBtn = true;
          element.showContentMore = true; // 内容是否超过六行
        } else {
          element.showMoreBtn = false;
        }
      });
      this.myCommentList = arr;
    } else if (res.code == 810) {
      this.isComment = 0;
    } else if (res.code == 41003) {
      this.commented = 0;
    } else if (res.code == 430) {
      this.bannedToPost = 1;
      this.bannedDay = res.data;
    } else if (res.code == 41001) {
      this.myCommentList = [];
    } else if (res.code == 41018) {
      this.isLogin = 0;
    }
  }

  // 我的--------------------------------------------------
  // 我的评价点赞
  public myCommentPraise(item) {
    this.handleComPra(3, item.is_praise, item.id);
  }
  // 我的评价展示回复
  public myHandleShowReply(item) {
    this.myCommentList.forEach((element) => {
      if (element.id == item.id) {
        if (element.replyShow == 1) {
          element.replyShow = 0;
        } else {
          this.getReplyList(3, item.id, 1);
        }
      }
    });
  }
  // 我的评价中回复点赞
  public myReplyPraise(item) {
    this.handleReplyPra(3, item.is_praise, item.itemId, item.imId);
  }
  // 我的评价展示回复输入框
  public myHandleShowReplyInp(item) {
    this.clickReply(3, item.itemId, item.imId);
  }
  // 我的评价发送回复
  public myHandleSendReply(item) {
    this.sendReply(item.type, item.id, item.item, 3, item.replyContent);
  }
  // 我的评价删除评价
  public myDelComment(id) {
    this.delMyComment(id);
  }
  // 我的评价删除回复
  public myDelReply(item) {
    this.delReply(3, item.imId, item.itemId);
  }
  // 我的评价回复翻页
  public myReplyChangePage(item) {
    this.getReplyList(3, item.id, item.page);
  }
  // 我的评价展示更多
  public myHandleShowMore(id) {
    this.handleShowContentMore(3, id);
  }
  // 热门----------------------------------------
  // 热评评价点赞
  public hotCommentPraise(item) {
    this.handleComPra(1, item.is_praise, item.id);
  }
  // 热评评价展示回复
  public hotHandleShowReply(item) {
    this.hotList.forEach((element) => {
      if (element.id == item.id) {
        if (element.replyShow == 1) {
          element.replyShow = 0;
        } else {
          this.getReplyList(1, item.id, 1);
        }
      }
    });
  }
  // 热评评价中回复点赞
  public hotReplyPraise(item) {
    this.handleReplyPra(1, item.is_praise, item.itemId, item.imId);
  }
  // 热评评价展示回复输入框
  public hotHandleShowReplyInp(item) {
    this.clickReply(1, item.itemId, item.imId);
  }
  // 热评评价发送回复
  public hotHandleSendReply(item) {
    this.sendReply(item.type, item.id, item.item, 1, item.replyContent);
  }
  // 热评评价删除评价
  public hotDelComment(id) {
    this.delMyComment(id);
  }
  // 热评评价删除回复
  public hotDelReply(item) {
    this.delReply(1, item.imId, item.itemId);
  }
  // 热评评价回复翻页
  public hotReplyChangePage(item) {
    this.getReplyList(1, item.id, item.page);
  }
  // 热评评价展示更多
  public hotHandleShowMore(id) {
    this.handleShowContentMore(1, id);
  }
  // 最新
  // 最新评价点赞
  public newCommentPraise(item) {
    this.handleComPra(2, item.is_praise, item.id);
  }
  // 最新评价展示回复
  public newHandleShowReply(item) {
    this.commentList.forEach((element) => {
      if (element.id == item.id) {
        if (element.replyShow == 1) {
          element.replyShow = 0;
        } else {
          this.getReplyList(2, item.id, 1);
        }
      }
    });
  }
  // 最新评价中回复点赞
  public newReplyPraise(item) {
    this.handleReplyPra(2, item.is_praise, item.itemId, item.imId);
  }
  // 最新评价展示回复输入框
  public newHandleShowReplyInp(item) {
    this.clickReply(2, item.itemId, item.imId);
  }
  // 最新评价发送回复
  public newHandleSendReply(item) {
    this.sendReply(item.type, item.id, item.item, 2, item.replyContent);
  }
  // 最新评价删除评价
  public newDelComment(id) {
    this.delMyComment(id);
  }
  // 最新评价删除回复
  public newDelReply(item) {
    this.delReply(2, item.imId, item.itemId);
  }
  // 最新评价回复翻页
  public newReplyChangePage(item) {
    this.getReplyList(2, item.id, item.page);
  }
  // 最新评价展示更多
  public newHandleShowMore(id) {
    this.handleShowContentMore(2, id);
  }

  // 获取回复列表       1   为热评列表     2 为最新列表  3  我的
  public async getReplyList(type, id, pagenum) {
    if (type == 1) {
      this.hotList.forEach((element) => {
        if (element.id == id) {
          element.replyShow = 1;
        }
      });
    } else if (type == 2) {
      this.commentList.forEach((element) => {
        if (element.id == id) {
          element.replyShow = 1;
        }
      });
    } else if (type == 3) {
      this.myCommentList.forEach((element) => {
        if (element.id == id) {
          element.replyShow = 1;
        }
      });
    }
    const obj: any = {
      token: this.$fn.cookies.getToken(),
      comment_id: id,
      box_game_id: this.$route.query.id,
      page: pagenum,
    };
    const res = await userCommentList(obj);
    if (res.code == 200) {
      const data = res.data.reply_list;
      data.data.forEach((element) => {
        element.showInput = 0;
      });
      if (type == 1) {
        this.hotList.forEach((element) => {
          if (element.id == id) {
            element.replyShow = 1;
            element.replyData = data;
          }
        });
      } else if (type == 2) {
        this.commentList.forEach((element) => {
          if (element.id == id) {
            element.replyShow = 1;
            element.replyData = data;
          }
        });
      } else if (type == 3) {
        this.myCommentList.forEach((element) => {
          if (element.id == id) {
            element.replyShow = 1;
            element.replyData = data;
          }
        });
      }
    }
  }
  // 收起回复      1   为热评列表     2 为最新列表
  public closeReply(type, id) {
    if (type == 1) {
      this.hotList.forEach((element) => {
        if (element.id == id) {
          element.replyShow = 0;
        }
      });
    } else if (type == 2) {
      this.commentList.forEach((element) => {
        if (element.id == id) {
          element.replyShow = 0;
        }
      });
    } else if (type == 3) {
      this.myCommentList.forEach((element) => {
        if (element.id == id) {
          element.replyShow = 0;
        }
      });
    }
  }
  // 点击回复     1   为热评列表     2 为最新列表
  public clickReply(type, pid, id) {
    if (type == 1) {
      this.hotList.forEach((element) => {
        if (element.id == pid) {
          //   element.replyData.data.forEach((item) => {
          //       item.showInput = 1;
          //   });
          element.replyData.data.forEach((item) => {
            if (item.id == id) {
              if (item.showInput == 1) {
                item.showInput = 0;
              } else {
                item.showInput = 1;
              }
            } else {
              item.showInput = 0;
            }
          });
        }
      });
    } else if (type == 2) {
      this.commentList.forEach((element) => {
        if (element.id == pid) {
          element.replyData.data.forEach((item) => {
            if (item.id == id) {
              if (item.showInput == 1) {
                item.showInput = 0;
              } else {
                item.showInput = 1;
              }
            } else {
              item.showInput = 0;
            }
          });
        }
      });
    } else if (type == 3) {
      this.myCommentList.forEach((element) => {
        if (element.id == pid) {
          element.replyData.data.forEach((item) => {
            if (item.id == id) {
              if (item.showInput == 1) {
                item.showInput = 0;
              } else {
                item.showInput = 1;
              }
            } else {
              item.showInput = 0;
            }
          });
        }
      });
    }
  }
  // 发送回复   listType 1为热评，2最新评论，3我的评价
  public async sendReply(type, id, item, listType, replyContent) {
    if (replyContent == "") {
      this.$Message.error("请输入内容");
      return false;
    }
    if (item.uid == this.$store.state.user.info.id) {
      this.$Message.error("请勿回复自己");
      return false;
    }
    const obj: any = {
      token: this.$fn.cookies.getToken(),
      comment_id: id,
      box_game_id: this.gameId,
      user_name: this.$store.state.user.info.nick_name,
      to_uid: item.uid,
      to_user_name: item.user_name,
      head_portrait: this.$store.state.user.info.head_img,
      //   content: type == 1 ? this.firstReply : this.footerReply,
      content: replyContent,
      reply_id: item.id,
      comment_content: item.content,
    };
    const res = await addUserComment(obj);
    if (res.code == 200) {
      //   this.getMyComment();
      //   this.getList();

      if (type == 1) {
        this.firstReply = "";
      } else {
        this.footerReply = "";
      }
      if (listType == 3) {
        this.myCommentList.forEach((element) => {
          if (element.id == id) {
            element.comment_num++;
          }
        });
      } else if (listType == 1) {
        this.hotList.forEach((element) => {
          if (element.id == id) {
            element.comment_num++;
          }
        });
      } else if (listType == 2) {
        this.commentList.forEach((element) => {
          if (element.id == id) {
            element.comment_num++;
          }
        });
      }
      this.getReplyList(listType, id, 1);
    } else {
      this.$Message.error(res.msg);
    }
  }
  // 删除回复   rid回复id，cid评论id
  public async delReply(type, rid, cid) {
    const obj = {
      token: this.$fn.cookies.getToken(),
      id: rid,
      box_game_id: this.gameId,
      comment_id: cid,
    };
    const res = await delUserComment(obj);
    if (res.code == 200) {
      this.getReplyList(type, cid, 1);
      if (type == 3) {
        this.myCommentList.forEach((element) => {
          if (element.id == cid) {
            element.comment_num--;
          }
        });
      } else if (type == 1) {
        this.hotList.forEach((element) => {
          if (element.id == cid) {
            element.comment_num--;
          }
        });
      } else if (type == 2) {
        this.commentList.forEach((element) => {
          if (element.id == cid) {
            element.comment_num--;
          }
        });
      }
    }
  }
  // 删除评价
  public async delMyComment(i) {
    const obj = {
      token: this.$fn.cookies.getToken(),
      id: i,
      box_game_id: this.gameId,
    };
    const res = await delComment(obj);
    if (res.code == 200) {
      this.getMyComment();
      this.getList();
    }
  }
  // 发表评价
  public async handleComment() {
    const $commentModal: any = this.$refs.commentModal;
    const res = await $commentModal.show(this.grade);
  }
  // 评论点赞  type 1 热评  2 最新  3 我的   praise 1 为点赞  2 为取消点赞
  public async handleComPra(type, praise, id) {
    if (!this.havePraise) {
      this.$Message.error("请勿连续点赞");
      return false;
    }
    const obj = {
      token: this.$fn.cookies.getToken(),
      box_game_id: this.gameId,
      comment_id: id,
      type: praise == 1 ? "2" : "1",
    };
    this.havePraise = false;
    const res = await commentPraise(obj);
    if (res.code == 200) {
      if (type == 3) {
        this.myCommentList.forEach((item) => {
          if (item.id == id) {
            item.is_praise = praise == 1 ? 0 : 1;
            if (praise) {
              item.praise_count = item.praise_count - 1;
            } else {
              item.praise_count = item.praise_count + 1;
            }
          }
        });
      } else if (type == 1) {
        this.hotList.forEach((item) => {
          if (item.id == id) {
            item.is_praise = praise == 1 ? 0 : 1;
            if (praise) {
              item.praise_count = item.praise_count - 1;
            } else {
              item.praise_count = item.praise_count + 1;
            }
          }
        });
      } else if (type == 2) {
        this.commentList.forEach((item) => {
          if (item.id == id) {
            item.is_praise = praise == 1 ? 0 : 1;
            if (praise) {
              item.praise_count = item.praise_count - 1;
            } else {
              item.praise_count = item.praise_count + 1;
            }
          }
        });
      }
      //   this.getList();
      //   //   } else {
      //   this.getMyComment();
      //   }
    }
    this.havePraise = true;
  }
  // 回复点赞  type 1 热评  2 最新  3 我的   praise 1 为点赞  2 为取消点赞
  // cid 为评论id，comment_id    rid 为回复id
  public async handleReplyPra(type, praise, cid, rid) {
    if (!this.haveReplyPraise) {
      this.$Message.error("请勿连续点赞");
      return false;
    }
    const obj = {
      token: this.$fn.cookies.getToken(),
      box_game_id: this.gameId,
      comment_id: cid,
      reply_id: rid,
      type: praise == 1 ? "2" : "1",
    };
    this.haveReplyPraise = false;
    const res = await replyPraise(obj);
    if (res.code == 200) {
      //   this.getReplyList(type, cid);
      if (type == 3) {
        this.myCommentList.forEach((item) => {
          if (item.id == cid) {
            item.replyData.data.forEach((element) => {
              if (element.id == rid) {
                element.is_praise = praise == 1 ? 0 : 1;
                if (praise) {
                  element.praise_count = element.praise_count - 1;
                } else {
                  element.praise_count = element.praise_count + 1;
                }
              }
            });
          }
        });
      } else if (type == 1) {
        this.hotList.forEach((item) => {
          if (item.id == cid) {
            item.replyData.data.forEach((element) => {
              if (element.id == rid) {
                element.is_praise = praise == 1 ? 0 : 1;
                if (praise) {
                  element.praise_count = element.praise_count - 1;
                } else {
                  element.praise_count = element.praise_count + 1;
                }
              }
            });
          }
        });
      } else if (type == 2) {
        this.commentList.forEach((item) => {
          if (item.id == cid) {
            item.replyData.data.forEach((element) => {
              if (element.id == rid) {
                element.is_praise = praise == 1 ? 0 : 1;
                if (praise) {
                  element.praise_count = element.praise_count - 1;
                } else {
                  element.praise_count = element.praise_count + 1;
                }
              }
            });
          }
        });
      }
    }
    this.haveReplyPraise = true;
  }
  // 评论点赞  type 1 热评  2 最新  3 我的   praise 1 为点赞  2 为取消点赞
  public async handleShowContentMore(type, id) {
    if (type == 3) {
      this.myCommentList.forEach((item) => {
        if (item.id == id) {
          item.showContentMore = !item.showContentMore;
        }
      });
    } else if (type == 1) {
      this.hotList.forEach((item) => {
        if (item.id == id) {
          item.showContentMore = !item.showContentMore;
        }
      });
    } else if (type == 2) {
      this.commentList.forEach((item) => {
        if (item.id == id) {
          item.showContentMore = !item.showContentMore;
        }
      });
    }
  }
}
